import type { AddNewDataFormValues } from "@/modules/add-new-data/lib/schema";
import type { ValidationNotice } from "@/modules/add-new-data/lib/validation";
import { ReviewSubmitStep as DesktopReviewSubmitStep } from "@/modules/add-new-data/components/review-submit-step-desktop";

type ReviewSubmitStepProps = {
  values: AddNewDataFormValues;
  notices?: ValidationNotice[];
  isSubmitting?: boolean;
  onSubmit?: () => void;
  submitLabel?: string;
};

export function ReviewSubmitStep({ values }: ReviewSubmitStepProps) {
  return <DesktopReviewSubmitStep values={values} />;
}
